import { render, staticRenderFns } from "./bellPopper.vue?vue&type=template&id=d165837c&scoped=true&"
import script from "./bellPopper.vue?vue&type=script&lang=js&"
export * from "./bellPopper.vue?vue&type=script&lang=js&"
import style0 from "./bellPopper.vue?vue&type=style&index=0&id=d165837c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d165837c",
  null
  
)

export default component.exports